import { useStaticQuery, graphql } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";

export const useImages = (): ImageDataLike => {
  const images = useStaticQuery(graphql`
    {
      allFile(
        filter: {
          extension: { eq: "webp" }
          relativeDirectory: { eq: "contact" }
        }
      ) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData(width: 400, placeholder: BLURRED)
          }
        }
      }
    }
  `);

  return images.allFile.nodes;
};
